module.exports = __webpack_public_path__ + "static/media/icon_watch.882e5e99.svg";